<template>
  <div>fly_data_two</div>
</template>
<script>
export default {
  name: "fly_data_two",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  destroyed() {},
  methods: {}
};
</script>
<style lang="stylus" scoped></style>
